import BraintreeFastlanePaymentMethod from './BraintreeFastlanePaymentMethod';

export default BraintreeFastlanePaymentMethod;
